import React from "react";

const OrderSummaryContainer = ({children, title}) => (
    <section className="order-summary">
        <h2 className="order-summary__title">
            {title}
        </h2>
        <div className="order-summary__wrapper">
            {children}
        </div>
    </section>
);

export {OrderSummaryContainer}